import React from "react"
import PropTypes from "prop-types"
import { TextField, InputAdornment, IconButton, Box } from "@mui/material"
import { NumericFormat } from "react-number-format"
import { ReactComponent as CalculadoraIcon } from "assets/customIcons/calculadora.svg"
import { ReactComponent as ArrowMeasures } from "assets/customIcons/measuresArrow.svg"

const QuantityInputWithToggle = ({
  toggleBenefits,
  handleToggleClick,
  value,
  disabled,
  onChange,
  onBlur,
  label,
}) => {
  return (
    <NumericFormat
      value={value}
      thousandSeparator={false}
      decimalSeparator="."
      customInput={TextField}
      decimalScale={3}
      locale="es-ES"
      label={label}
      variant="filled"
      disabled={disabled}
      size="small"
      fullWidth
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={
                toggleBenefits ? "Mostrar calculadora" : "Mostrar beneficios"
              }
              onClick={handleToggleClick}
              edge="end"
            >
              {toggleBenefits ? <ArrowMeasures /> : <CalculadoraIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{
        backgroundColor: "white",
        "& .MuiFilledInput-root": {
          border: "none",
          backgroundColor: "transparent",
          boxShadow: "none",
        },
        "& .MuiFilledInput-root:before": { borderBottom: "none" },
        "& .MuiFilledInput-root:after": { borderBottom: "none" },
        "& .MuiFilledInput-root.Mui-disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.08)",
          color: "rgba(0, 0, 0, 1)",
        },
        "& .MuiFilledInput-root.Mui-disabled input": {
          WebkitTextFillColor: "revert",
        },
      }}
      onValueChange={values => {
        const newValue = values.floatValue ?? ""
        onChange(newValue)
      }}
      onBlur={e => {
        const value = e.target.value === "" ? 0 : e.target.value
        onBlur(value)
      }}
    />
  )
}

QuantityInputWithToggle.propTypes = {
  toggleBenefits: PropTypes.bool.isRequired,
  handleToggleClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  label: PropTypes.string,
}

export default QuantityInputWithToggle
